import { RouteObject } from 'react-router-dom';
import ErrorPage, { Page404 } from 'src/error-page';
import EmailVerificationGuard from './verify-email/verify-email-guard';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

const LayoutComponent = lazyConReintento(() => import('./layout/layout'));
const RegistrationCompletedView = lazyConReintento(() => import('./registration-completed'));
const CreatePersonProfileWizard = lazyConReintento(() => import('./create-profile/person'));
const CreateEnterpriseProfileWizard = lazyConReintento(() => import('./create-profile/enterprise'));
const CreateEnterpriseUserProfileWizard = lazyConReintento(() => import('./create-profile/enterprise-user'));
const VerifyEmailView = lazyConReintento(() => import('./verify-email/verify-email'));
const LinkedinUrlPage = lazyConReintento(() => import('./create-profile/enterprise/linkedin-url-page'));
const CreateEnterpriseProfileFromDraftShortlistWizard = lazyConReintento(() => import('./create-profile/draft-shortlist'));

const onBoardingRoutes: RouteObject[] = [
  {
    path: '/onboarding',
    element: diferida(<LayoutComponent />),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Page404 />
      },
      {
        path: 'linkedin-url',
        element: diferida(<LinkedinUrlPage />)
      },
      {
        path: 'registration-completed',
        element: diferida(
          <EmailVerificationGuard mode="require">
            <RegistrationCompletedView />
          </EmailVerificationGuard>
        )
      },
      {
        path: 'verify-email',
        element: diferida(
          <EmailVerificationGuard mode="redirectIfVerified">
            <VerifyEmailView />
          </EmailVerificationGuard>
        )
      },
      {
        path: 'create-service-profile/:step?/:subStep?',
        element: diferida(<CreatePersonProfileWizard />)
      },
      {
        path: 'create-enterprise-profile/:step?/:subStep?',
        element: diferida(
          <EmailVerificationGuard mode="require">
            <CreateEnterpriseProfileWizard />
          </EmailVerificationGuard>
        )
      },
      {
        path: 'create-enterprise-from-shortlist/:step?/:subStep?',
        element: diferida(
          <EmailVerificationGuard mode="require">
            <CreateEnterpriseProfileFromDraftShortlistWizard />
          </EmailVerificationGuard>
        )
      },
      {
        path: 'create-enterprise-user-profile/:step?/:subStep?',
        element: diferida(
          <EmailVerificationGuard mode="require">
            <CreateEnterpriseUserProfileWizard />
          </EmailVerificationGuard>
        )
      },
      {
        path: '*',
        element: <Page404 />
      }
    ]
  }
];

export default onBoardingRoutes;
